import { Booker, Target } from '../components/Booker';
import { constants } from '../constants';
import { useFetchUser } from '../hooks/useFetchUser';
import { useTokens } from '../hooks/useTokens';
import { useReceptionists } from '../services/receptionists/useReceptionists';

export const BookerRoute = () => {
  const { data: user } = useFetchUser();
  const { tokens } = useTokens();
  const { activeReceptionist } = useReceptionists();

  return (
    <div className="flex items-center flex-col">
      <div className="w-full h-[calc(100vh_-_3rem)]">
        <Booker
          target={constants.mode as Target}
          product={constants.product}
          user={user}
          tokens={tokens}
          invoiceMention={activeReceptionist}
        />
      </div>
    </div>
  );
};
